import { render, staticRenderFns } from "./receiveOrder.vue?vue&type=template&id=aad972e0&scoped=true&"
import script from "./receiveOrder.vue?vue&type=script&lang=js&"
export * from "./receiveOrder.vue?vue&type=script&lang=js&"
import style0 from "./receiveOrder.vue?vue&type=style&index=0&id=aad972e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad972e0",
  null
  
)

export default component.exports